/**
 * The backend returns collections in a few different envelopes depending on the
 * endpoint (bare array, `{ data: [] }`, `{ data: { items: [] } }`, `{ content: [] }`).
 * These helpers normalize that so pages can always work with a plain array/object.
 */
export const unwrapList = (payload: any, ...keys: string[]): any[] => {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;

  const candidates = [...keys, "content", "items", "results", "rows"];

  for (const key of candidates) {
    if (Array.isArray(payload[key])) return payload[key];
  }

  if (payload.data) return unwrapList(payload.data, ...keys);

  return [];
};

export const unwrapItem = (payload: any, ...keys: string[]): any => {
  if (!payload) return null;
  if (Array.isArray(payload)) return payload[0] ?? null;

  for (const key of keys) {
    if (payload[key]) return payload[key];
  }

  if (payload.data && !payload.id) return unwrapItem(payload.data, ...keys);

  return payload;
};

export const getErrorMessage = (error: any, fallback: string): string =>
  error?.response?.data?.message ||
  error?.response?.data?.msg ||
  error?.response?.data?.error ||
  error?.message ||
  fallback;
